<template>
  <div class="sky-poc-project-detail">
    <div class="sky-poc-project-detail__title">
      <div class="title-content">
        <div class="customer attr-item">当前客户：{{ detail.customer }}</div>
      </div>
      <div class="wsp-margin-left-12 wsp-width-20">
        <div :class="` ${!uplaodStatus ? 'bg-3bb113 el-icon-upload' : 'color-E69D01 el-icon-loading '}`">
          {{ !uplaodStatus ? '变更已保存' : '变更保存中' }}
        </div>
      </div>
    </div>

    <div class="sky-poc-project-detail__content">
      <div class="content-progress">
        <custom-step
          :steps="progressSteps"
          :activityStep="{ main: mainStep, children: childStep }"
          @changeMenu="changeMenu"
        ></custom-step>
      </div>
      <div class="stage-view-content">
        <component-view
          :data="{
            projectId: projectId,
            stage: stage,
            industryId: industryId,
            customer: detail.customer,
            createBytmp: createBytmp
          }"
          :ref="activiteViewPage.component"
          :name="activiteViewPage.component"
          :viewComponent="activiteViewPage.component"
          @handelToAutoNext="handelToAutoNext"
          @changeProjectId="changeProjectId"
          @showBtns="showBtns"
          :key="componentKey"
        ></component-view>
      </div>
    </div>

    <div class="sky-poc-project-detail__toolbar">
      <div class="toolbar-title bg-red el-icon-info" v-show="hasSave">
        <span>"保存更改"：仅保存本步骤修改内容，不跳转步骤</span>
      </div>
      <div class="toolbar-content">
        <div class="toolbar-btns">
          <el-button
            class="toolbar-btns-item "
            type="info"
            icon="sk-icon-home"
            @click="gotoHomePocProjectList"
            size="mini"
            >我的项目</el-button
          >

          <el-tooltip class="item" effect="dark" content="查看各步骤数据可点击：步骤标签进行切换" placement="top">
            <el-button
              class="toolbar-btns-item "
              icon="el-icon-arrow-left"
              v-if="preNext"
              @click="gotoPreStep"
              size="mini"
              >上一步</el-button
            >
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="查看各步骤数据可点击：步骤标签进行切换" placement="top">
            <el-button
              class="toolbar-btns-item "
              :loading="loadingNext"
              @click="gotoNextStep('NEXT')"
              :disabled="saveIng || uplaodStatus"
              v-if="hasNext"
              size="mini"
              >下一步<i class="el-icon-arrow-right el-icon--right"></i
            ></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="查看各步骤数据可点击：步骤标签进行切换" placement="top">
            <el-button
              class="toolbar-btns-item "
              :loading="loadingNext"
              @click="gotoNextStep('SKIP')"
              :disabled="saveIng || uplaodStatus"
              v-if="enableSkipNext"
              size="mini"
              type="success"
              >跳过<i class="el-icon-arrow-right el-icon--right"></i
            ></el-button>
          </el-tooltip>
          <el-button
            class="toolbar-btns-item sk-icon-save "
            icon="el-icon-save"
            :disabled="saveIng || uplaodStatus"
            @click="saveStep"
            v-if="hasSave"
            size="mini"
            type="success"
            >保存更改</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Steps, Step, Button, Tooltip } from 'element-ui'
import { action } from 'sky-engine/api/index'

import componentView from './component'
import customStep from './step/index'

import { POC_MNG } from '@/api/apiModules'
import { updateFlowStatus, getDetail } from '@/api/deliveryProject'
import { getIndustryList, getSystemSpecEditState } from '@/api/setting'

export default {
  name: 'SkyPocProjectDetailContent',
  components: {
    [Steps.name]: Steps,
    [Step.name]: Step,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
    customStep,
    componentView
  },
  props: {
    projectId: {
      type: String,
      default: () => {
        return null
      }
    },
    customer: {
      type: String
    },
    industryId: {
      type: String
    },
    createBytmp: {
      type: Boolean
    },
    stage: {
      type: String,
      default: () => {
        return 'MDR_PROJECT_INIT'
      }
    }
  },
  computed: {},
  created() {
    this.queryProjectDetail()
    for (let index = 0; index < this.progressSteps.length; index++) {
      const main = this.progressSteps[index]
      for (let y = 0; y < main.children.length; y++) {
        const children = main.children[y]

        if (children.childStage.includes(this.stage)) {
          this.mainStep = index
          main.status = 'inprogess'
          this.childStep = y
          children.status = 'inprogess'
          break
        } else {
          children.status = 'done'
          main.status = 'done'
        }
      }
    }
    this.activiteViewPage = this.progressSteps[this.mainStep].children[this.childStep]

    if (
      this.mainStep === this.progressSteps.length - 1 &&
      this.childStep == this.progressSteps[this.mainStep].children.length - 1
    ) {
      this.hasNext = false
      this.progressSteps[this.mainStep].status = 'done'
      this.progressSteps[this.mainStep].children[this.childStep].status = 'done'
    } else {
      this.progressSteps[this.mainStep].status = 'inprogess'
      this.progressSteps[this.mainStep].children[this.childStep].status = 'inprogess'
    }
  },
  beforeDestroy() {},
  data() {
    return {
      componentKey: 0,
      activiteViewPage: null,
      viewIsPreStep: false,
      uplaodStatus: false,
      saveIng: false,
      mainStep: 0,
      loadingNext: false,
      timer: null,
      childStep: 0,
      hasNext: true,
      preNext: true,
      hasSave: false,
      enableSkipNext: false,
      activiteStage: null,
      detail: {},
      industryMap: {},
      progressSteps: [
        {
          name: '方案设计阶段',
          status: 'todo',
          children: [
            {
              name: '方案设计',
              status: 'todo',
              component: 'SkyStepViewDemandSurvey',
              childStage: [
                'MDR_DEPLOY_PROJECT_INIT',
                'MDR_DEPLOY_JOB_PC_INFO',
                'MDR_DEPLOY_REQUIREMENT_CHECK',
                'MDR_DEPLOY_NETWORK_INFO'
              ]
            },
            {
              name: '方案导出',
              status: 'todo',
              component: 'StepViewCaseReport',
              childStage: ['MDR_DEPLOY_SOLUTION_BUILD']
            }
          ]
        }
      ]
    }
  },
  mounted() {},
  destroyed() {
    this.activiteViewPage = null
  },
  methods: {
    reloadData() {
      //重新加载数据
      this.componentKey = this.componentKey + 1
    },
    showBtns(params) {
      this.hasNext = params.nextStep
      this.preNext = params.preStep
      this.hasSave = params.saveStep
      this.enableSkipNext = params.enableSkipNext
    },
    handelToAutoNext() {
      this.gotoNextStep()
    },
    changeProjectId(params) {
      this.projectId = params.projectId
      this.detail.customer = params.customer
      this.industryId = params.industryId
      this.customer = params.customer
    },
    changeViewIsPreStep(params) {
      this.viewIsPreStep = params
    },
    queryProjectDetail() {
      getIndustryList({}).then(res => {
        res.data.content.itemArr.forEach(element => {
          this.industryMap[element.id] = element.industryName
        })
      })
      if (this.projectId) {
        getDetail({ id: this.projectId }).then(res => {
          this.detail = res.data.content
          this.industryId = this.detail.industryId
        })
      }
    },
    gotoHomePocProjectList() {
      action(POC_MNG, 'deleteLock')
        .then(response => {})
        .catch(e => {
          throw e
        })
      this.activiteViewPage = null
      this.$store.dispatch('ReturnPage')
    },
    async saveStep() {
      let refContent = this.activiteViewPage.component
      this.saveIng = !this.saveIng

      this.$refs[refContent].$children[0].saveStep().then(result => {
        this.saveIng = !this.saveIng

        if (!result) {
          return
        }
      })
    },
    gotoNext() {
      let processParams = {
        main: this.mainStep,
        children: this.childStep
      }
      let childStep = this.progressSteps[this.mainStep].children
      if (this.childStep < childStep.length - 1) {
        this.progressSteps[this.mainStep].children[this.childStep].status = 'done'
        processParams.children += 1
      } else if ((this.childStep = childStep.length - 1)) {
        processParams.main += 1
        processParams.children = 0
      }
      updateFlowStatus({
        projectId: this.projectId,
        flowStatus: this.progressSteps[processParams.main].children[processParams.children].childStage[0]
      }).then(res => {})
      if (
        processParams.main === this.progressSteps.length - 1 &&
        processParams.children == this.progressSteps[processParams.main].children.length - 1
      ) {
        this.hasNext = false
        this.progressSteps[processParams.main].status = 'done'
        this.progressSteps[processParams.main].children[processParams.children].status = 'done'
      } else {
        this.progressSteps[this.mainStep].status = 'inprogess'
        this.progressSteps[this.mainStep].children[this.childStep].status = 'inprogess'
      }
      this.changeMenu(processParams)
      this.loadingNext = false
    },
    async gotoNextStep(status) {
      let refContent = this.activiteViewPage.component
      this.loadingNext = true
      if (this.enableSkipNext && status === 'SKIP') {
        this.$refs[refContent].$children[0]
          .skipToNext()
          .then(result => {
            this.loadingNext = false

            if (!result) {
              return
            }
            this.gotoNext()
          })
          .catch(err => {})
      } else {
        this.$refs[refContent].$children[0]
          .gotoNextStep()
          .then(result => {
            this.loadingNext = false
            if (!result) {
              return
            }
            this.gotoNext()
          })
          .catch(err => {})
      }
    },
    async gotoPreStep() {
      var state = false
      await getSystemSpecEditState().then(res => {
        if (res.data.content.maintenanceState) {
          this.$store.dispatch('OpenNotification', {
            message: res.data.content.message,
            type: 'error'
          })
          state = true
          return
        }
      })
      if (state) {
        return
      }

      let refContent = this.activiteViewPage.component
      let enablePrev = this.$refs[refContent].$children[0].gotoPreStep()
      if (!enablePrev) {
        return
      }
      let processParams = {
        main: this.mainStep,
        children: this.childStep
      }
      if (processParams.children > 0) {
        this.progressSteps[this.mainStep].children[this.childStep].status = 'todo'
        processParams.children--
      } else {
        this.progressSteps[this.mainStep].children[this.childStep].status = 'todo'
        this.progressSteps[this.mainStep].status = 'todo'
        processParams.main--
        processParams.child = 0
      }

      var gotoView = this.progressSteps[processParams.main].children[processParams.children]

      updateFlowStatus({
        projectId: this.projectId,
        flowStatus: gotoView.childStage[gotoView.childStage.length - 1]
      }).then(res => {})

      this.stage = gotoView.childStage[gotoView.childStage.length - 1]
      this.progressSteps[processParams.main].status = 'inprogess'
      this.progressSteps[processParams.main].children[processParams.children].status = 'inprogess'
      this.changeMenu(processParams)
    },
    changeProgessData() {},
    changeMenu(params) {
      this.mainStep = params.main
      if (params.children) {
        this.childStep = params.children
      } else {
        this.childStep = 0
      }

      this.activiteViewPage = this.progressSteps[this.mainStep].children[this.childStep]
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(poc-project-detail) {
  height: 100%;
  @include e(title) {
    height: 36px;
    z-index: 2;
    width: 600px;
    position: absolute;
    .title-content {
      line-height: 33px;
      font-size: 18px;
      padding: 0 6px;
      margin: 12px 6px;
      display: flex;
      background: linear-gradient(to right, #ebebeb, #fff);
      .attr-item {
        padding: 0 3px;
      }
    }
  }
  @include e(content) {
    height: 90%;
    display: flex;
    .content-progress {
      margin-top: 48px;
      padding: 8px 18px;
      width: 12%;
      height: 80vh;
    }
    .stage-view-content {
      width: 88%;
      height: 100%;
      .content-step-progress {
        height: 36px;
        .content-step-content {
          float: right;
          width: 70%;
          .el-steps--simple {
            padding: 6px 12px !important;
          }
        }
      }
    }
  }
  @include e(toolbar) {
    .toolbar-title {
      position: absolute;
      padding-top: 6px;
      font-size: 14px;
      left: 50%;
      transform: translateX(-50%);
    }
    .toolbar-content {
      box-shadow: 0 0 12px 0 rgb(24 44 108 / 15%);
      height: 88px;
      justify-content: center;
      align-items: center;
      display: flex;
      .toolbar-btns {
        .toolbar-btns-item {
          margin-right: 12px;
        }
      }
    }
  }
}
</style>
